module.exports = __webpack_public_path__ + "bq.svg?c038a38114772bfc160299d59aa68ee8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bq.svg
// module id = 763
// module chunks = 27